export default class Slideshow {
    constructor(elem, APP) {
        this.elem = elem
        this.groupCells = 1;
        this.flkty = null;
        this.timeout = null;
    }

    getCells() {
        if (window.matchMedia('(max-width: 768px)').matches) {
            return 1
        } else {
            return 3
        }
    }

    setupCarousel() {
        this.flkty = new Flickity(this.elem, {
            imagesLoaded: true,
            contain: true,
            setGallerySize: false,
            autoPlay: false,
            pageDots: true,
            prevNextButtons: false,
            groupCells: 1,
            wrapAround: true,
            cellAlign: 'left',
            lazyLoad: 1
        })

        window.postCarousel = this.flkty; // in case we need access elsewhere
    }

    onResize() {
        if (this.timeout) {
            window.cancelAnimationFrame(this.timeout)
        }

        this.timeout = window.requestAnimationFrame(() => {
            var prevGroupCells = this.groupCells
            this.groupCells = this.getCells()
            if (this.groupCells !== prevGroupCells) {
                this.flkty.destroy()
                this.setupCarousel()
            }
        }, false)
    }

    init() {
        console.log('running!')
        this.groupCells = this.getCells()
        this.setupCarousel()
        window.addEventListener('resize', () => { this.onResize() })
    }
}